<style scoped lang="scss">
    h4 {
        margin: 0;
    }
    .select-wrapper {
        label {
            padding-left: 10px;
        }
        input {
            margin-left: 20px;
        }
    }
    .info-wrapper {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        label {
            display: inline-block;
            width: 330px;
        }
        .text-input {
            width: 265px;
        }
    }
    table {
        tr {
            border-bottom: 1px dashed #efefef;
        }
    }
</style>

<template>
    <div class="uk-width-1-1 uk-grid">
        <header-row></header-row>
        <div class="uk-width-1-1">
            <h4>Household Member's Name: {{ fullName }}</h4>
            <h4>Property Address: {{ propertyAddress }}</h4>
        </div>
        <div class="uk-width-1-1 uk-margin-top">
            <p><b>Within the last {{ programSettings['required-days-of-income-proof'] }} days, did you receive income from any of the following sources?</b></p>
            <table class="uk-table">
                <thead>
                <tr>
                    <th>Income Type</th>
                    <th>Amount</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, idx) in incomes">
                    <td width="70%">{{ item.label }}</td>
                    <td>$ {{ getAnnualIncomeFromIncomeValue(item) }}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="html2pdf__page-break"></div>
        <header-row></header-row>

        <template v-for="(item, idx) in incomes">
            <div class="contact-info-wrapper" v-if="item.require_interval && getAnnualIncomeFromIncomeValue(item)">
                <div class="uk-width-1-1 uk-margin-top">
                    <h4>{{ item.label }}</h4>
                    <div class="info-wrapper">
                        <label>Name of Employer / Former Employer: {{ item.additional_info.employer_name }}</label>
                        <hr/>
                    </div>
                    <div class="info-wrapper">
                        <label>Name of Contact Person to Verify Employment:  {{ item.additional_info.contact_name }}</label>
                        <hr/>
                    </div>
                    <div class="info-wrapper">
                        <label>Phone Number of Contact Person:  {{ item.additional_info.contact_phone }}</label>
                        <hr/>
                    </div>
                </div>
            </div>
        </template>

        <div class="uk-width-1-1 uk-margin-large-top">
            <p>Under penalty of perjury, I certify that the information presented in this certification is true and accurate to the best of my knowledge.  I further understand that providing false representations constitutes an act of fraud. False, misleading, or incomplete information may result in the repayment of any funds received through the <b>{{ program['program_abbreviation'] }}</b> Program and other remedies available under applicable law.  I also give the <b>{{ program['agency_short_name'] }}</b> and its partners permission to obtain a copy of any tax returns from the Internal Revenue Service and to verify income and other information provided herein from other State agencies.</p>
        </div>

        <div class="uk-width-1-1">
            <signatures label="Printed Name of Household Member"></signatures>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters} from "vuex";
    import ApplicantData from "../Partials/ApplicantData";
    import ApplicantIncome from "../Partials/ApplicantIncome";
    import HeaderRow from "../Partials/HeaderRow";
    import ReviewResults from "../Partials/ReviewResults";
    import AttachedDocuments from "../Partials/AttachedDocuments";
    import BlankPage from "../Partials/BlankPage";
    import PrintableSignature from "../Partials/PrintableSignature";
    import Signatures from "../Partials/Signatures";

    export default {
        name: "NoIncomeAttestation",
        props: {
            member: {
                type: Object,
                default: {},
            },
            incomes: {
                type: Array,
                default: [],
            },
        },
        data() {
            return {
            }
        },
        components: {
            Signatures,
            PrintableSignature,
            BlankPage, AttachedDocuments, ReviewResults, HeaderRow, ApplicantIncome, ApplicantData},
        computed: {
            ...mapState('Application', {
                application: 'application',
                applicant: 'applicant',
            }),
            ...mapGetters('Application', [ 'program', 'programSettings' ]),
            fullName() {
                return this.member.first_name + ' ' + this.member.last_name
            },
            propertyAddress() {
                let result = ''
                if (this.applicant.property_address)
                {
                    result = `${this.applicant.property_address.line_1} ${this.applicant.property_address.line_2}, ${this.applicant.property_address.city}, ${this.applicant.property_address.state}, ${this.applicant.property_address.zip}`
                }
                return result
            }
        },
        methods: {
            getAnnualIncomeFromIncomeValue(income) {
                let amount;
                let value = income.income_amount

                let assets = [];
                if (income.doc_type === 'paystub')
                {   
                    assets = income.paystubs
                } else {
                    assets = income.attestations
                }
                value = _.reduce(assets, (sum, item) => {
                    return sum + item.income_amount
                }, 0);
                value = assets.length ? value / assets.length : 0;

                switch(income.interval) {
                    case 'monthly':
                    case 'other':
                        amount = parseFloat(value) * 12;
                        break;

                    case 'weekly':
                        amount = parseFloat(value) * 52;
                        break;

                    case 'biweekly':
                        amount = parseFloat(value) * 26;
                        break;

                    case 'bimonthly':
                        amount = parseFloat(value) * 24;
                        break;

                    case 'annually':
                        amount = parseFloat(value);
                        break;

                    default: amount = parseFloat(value) * 12;
                }

                return amount ? amount : 0;

            },
        }
    }
</script>
